// src/atoms/userAtom.js
import { getLoginInfo, ILoginAdminInfo } from '@/common/api/api'
import { atom, useSetRecoilState } from 'recoil'


const defaultUserInfo: {
  entName?: string,
  entAdminName?: string,
  adminInfo?: ILoginAdminInfo,
  email?: string,
} = {
  entName: '',
  entAdminName: '',
}

export const loginUserInfo = atom({
  key: 'loginUserInfo', // NOTE: 唯一的ID
  default: { ...defaultUserInfo }, // 默认值
})


const useUpdateUser = () => {
  const setUser = useSetRecoilState(loginUserInfo)

  const updateUser = async (type?: 'delete') => {
    if (type === 'delete') {
      setUser(() => ({ ...defaultUserInfo }))
    } else {
      try {
        const newUserInfo = await getLoginInfo()
        setUser(() => ({
          entName: newUserInfo?.entName,
          entAdminName: newUserInfo?.entAdminName,
          adminInfo: newUserInfo,
        }))
      } catch (error) {
        console.error(error)
      }
    }
  }
  return updateUser
}

export default useUpdateUser
